import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import { ArrowUp, ArrowDown } from 'Utils/SvgIcons';
import classnames from 'classnames';
import Checkbox from 'Utils/Checkbox';

// Shared recursive category tree for desktop and mobile
const SfCategoryTree = ({
  sfCategories,
  open,
  toggleOpen,
  checkCategorySelected,
  handleCategorySelected,
  currentCategory,
  theme,
  depth = 1,
  parentId = null,
  showCheckbox = false,
}) => {
  // Find all categories whose parentId matches
  const children = sfCategories.filter(
    (cat) => String(cat.parentId) === String(parentId)
  );
  if (!children.length) return null;
  return children.map((cat) => {
    const isExpanded = open[cat.id];
    return [
      <ListItem
        key={cat.id}
        style={{ paddingLeft: depth * 16 }}
        className={classnames('categoryNav', {
          open: isExpanded,
          secondary: cat.childrenCount === 0 && depth > 1,
        })}
      >
        <div className='category-checkbox'>
          {showCheckbox && (
            <Checkbox
              checked={checkCategorySelected(cat)}
              onCheck={(_e, checked) => handleCategorySelected(checked, cat)}
            />
          )}
          <a className='categoryName' href={`/shop${cat.path}`}>
            {cat.name}
          </a>
        </div>
        {sfCategories.some((c) => String(c.parentId) === String(cat.id)) && (
          <a
            onClick={() => toggleOpen(cat)}
            className={classnames({
              arrowPreScott: theme === 'preScott',
              arrowOpen: isExpanded,
            })}
          >
            {isExpanded ? <ArrowUp /> : <ArrowDown />}
          </a>
        )}
      </ListItem>,
      isExpanded ? (
        <Collapse in={isExpanded} unmountOnExit key={`collapse-${cat.id}`}>
          <List disablePadding>
            <SfCategoryTree
              sfCategories={sfCategories}
              open={open}
              toggleOpen={toggleOpen}
              checkCategorySelected={checkCategorySelected}
              handleCategorySelected={handleCategorySelected}
              currentCategory={currentCategory}
              theme={theme}
              depth={depth + 1}
              parentId={cat.id}
              showCheckbox={showCheckbox}
            />
          </List>
        </Collapse>
      ) : null,
    ];
  });
};

export default SfCategoryTree;
